import { useTranslation } from "react-i18next";
import { TableLayout } from "../../layout/TableLayout";
import { Stack } from "@mui/material";
import LinkedInIcon from '@mui/icons-material/LinkedIn';

export const NetworkingTable = ({ rows }) => {
  const { t } = useTranslation("global");

  const columns = [
    {
      field: "fullName",
      headerName: t("partnerlist.columnName"),
      minWidth: 220,
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) =>
        `${params.row.name || ""} ${params.row.surnames || ""}`,
    },
    {
      field: "email",
      headerName: t("partnerlist.columnEmail"),
      minWidth: 220,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "country",
      headerName: t("partnerlist.columnCountry"),
      minWidth: 220,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "linkedin",
      headerName: t("networking.columnLinkedin"),
      minWidth: 80,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          !['', null, undefined].includes(params.row.linkedin) && (
            <Stack direction="row" gap={0}>
              <a href={params.row.linkedin} target="_blank" rel="noreferrer" style={{ color: '#0a66c2' }}>
                <LinkedInIcon fontSize="large"/>
              </a>
            </Stack>
          )
        );
      },
    },
  ];

  return (
    <>
      <TableLayout
        rows={rows}
        columns={columns}
        title="networking"
      />
    </>
  );
};
